import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, KeyRound, CheckCircle, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd !== confirm) {
      toast.error("Le password non coincidono");
      return;
    }
    if (pwd.length < 8) {
      toast.error("La password deve avere almeno 8 caratteri");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
        <div className="bg-white border border-red-200 rounded-lg p-8 max-w-md w-full text-center">
          <p className="text-red-700 font-medium">Token mancante.</p>
          <Link to="/login" className="text-blue-600 text-sm mt-4 inline-block">Torna al login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] p-6">
      <div className="bg-white border border-slate-200 rounded-lg p-8 max-w-md w-full">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-9 w-9 rounded-md bg-blue-600 flex items-center justify-center">
            <Building2 className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="font-display font-semibold tracking-tight">Assicura</div>
            <div className="text-xs text-slate-500">Reimposta password</div>
          </div>
        </div>

        {done ? (
          <div className="text-center py-6">
            <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto mb-3" />
            <h2 className="font-display text-xl font-semibold">Password aggiornata</h2>
            <p className="text-sm text-slate-500 mt-2">Ora puoi accedere con la nuova password.</p>
            <Button data-testid="goto-login-btn" onClick={() => navigate("/login")} className="mt-6 bg-[#0F172A] hover:bg-[#1E293B]">
              Vai al login
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-600 mb-4">Imposta una nuova password (minimo 8 caratteri).</p>
            <div>
              <Label>Nuova password</Label>
              <Input data-testid="new-password" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} className="mt-1.5 h-11" required />
            </div>
            <div>
              <Label>Conferma password</Label>
              <Input data-testid="confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1.5 h-11" required />
            </div>
            <Button data-testid="reset-submit" type="submit" disabled={loading} className="w-full h-11 bg-[#0F172A] hover:bg-[#1E293B]">
              {loading ? "Aggiornamento…" : (<><KeyRound className="h-4 w-4 mr-2" /> Aggiorna password</>)}
            </Button>
            <Link to="/login" className="text-xs text-slate-500 hover:text-slate-700 inline-flex items-center gap-1 mt-2">
              <ArrowLeft className="h-3 w-3" /> Torna al login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}
